export type Place = {
  placeId: string;
  displayName: string;
  latitude: number;
  longitude: number;
  geohash: string;
};

export type Country = {
  name: string;
  flag: string;
  code: string;
  dial_code: string;
};
